<template>
    <NavbarLogged />
    <ErrorPage v-if="error" :error="error" />
</template>

<script setup lang="ts">
    import {ErrorPage, NavbarLogged} from '#components';

    defineProps({
        error: Object,
    });
</script>
